export default {
  showPreview: 'Signalvorschau anzeigen',
  hidePreview: 'Signalvorschau ausblenden',
};
